import { ArrowBackRounded, DoneAll } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { action, API, controller } from "api";
import { AppContext } from "App";
import { Button } from "controls";
import { PrintDiv, ToFormData } from "hooks";
import { Printer } from "lucide-react";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LabelPrintLayout from "./PrintLayout/LabelPrintLayout";

const Header = ({ values, setValues }) => {
  const { setLoader, loader } = useContext(AppContext);
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/print_label_history");
  };

  const handlePrint = () => {
    PrintDiv("printLabel");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (values && values.items.length > 0) {
      setLoader(true);

      const onComplete = (res) => {
        setLoader(false);
        if (res?.status === 200) {
          setValues((j) => ({ ...j, id: res.result?.id }));
          handlePrint();
        } else toast.error(res.msg);
      };

      API(controller.PrintLabel + action.Post).post(
        ToFormData({
          ...values,
          items: [
            ...values.items.map((j) => ({ ...j, prod: "", varProd: "" })),
          ],
          createDate: new Date().toISOString(),
        }),
        onComplete
      );
    } else toast.error("Please select items to print.");
  };

  return (
    <>
      <div className="hidden" id="printLabel">
        <LabelPrintLayout data={values} />
      </div>

      <div className="flex justify-between items-center p-[10px]">
        <div className="flex items-center gap-[10px]">
          <div>
            <IconButton size="small" onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
          </div>

          <div>
            <h1 className="form-title font-bold tracking-wider text-gray-500 uppercase">
              Print Label
            </h1>
          </div>
        </div>

        <div>
          {values.id ? (
            <div className="flex gap-2">
              <Button
                onClick={handlePrint}
                startIcon={<Printer className="h-[20px]" />}
                variant="text"
              >
                Print Again
              </Button>
              <Button
                onClick={handleClose}
                color="success"
                startIcon={<DoneAll className="h-[20px]" />}
              >
                Done
              </Button>
            </div>
          ) : (
            <Button
              type="submit"
              loading={loader}
              onClick={handleSubmit}
              startIcon={<Printer className="h-[20px]" />}
            >
              Submit Print
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
